export default __webpack_public_path__ + "static/media/img5.7ee49d2e.png";